import { PaymentType, } from "@wayke-se/ecom";
export const getPaymentMethodTitle = (type) => {
    switch (type) {
        case PaymentType.Lease:
            return "Privatleasing";
        case PaymentType.Loan:
            return "Billån";
        case PaymentType.Cash:
            return "Kontant";
        default:
            return "";
    }
};
const getLoanPaymentOptions = (orderOptions) => {
    if (!orderOptions) {
        return null;
    }
    return orderOptions
        .getPaymentOptions()
        .find((p) => p.type === PaymentType.Loan);
};
export const getLoanDetails = (orderOptions, paymentLookup) => {
    return paymentLookup
        ? paymentLookup
        : getLoanPaymentOptions(orderOptions).loanDetails;
};
export const getLoanInformation = (orderOptions) => {
    const loanPaymentOptions = getLoanPaymentOptions(orderOptions);
    if (loanPaymentOptions) {
        return {
            name: loanPaymentOptions.name,
            unit: loanPaymentOptions.unit,
        };
    }
    return {
        name: "",
        unit: "",
    };
};
